import { instrumentMethod, Observable } from '@datadog/browser-core';
export function createWindowOpenObservable() {
  var observable = new Observable();
  var _instrumentMethod = instrumentMethod(window, 'open', function () {
      return observable.notify();
    }),
    stop = _instrumentMethod.stop;
  return {
    observable: observable,
    stop: stop
  };
}